import { useGetShippingMethodsQuery } from '@api/api';
import { TextCodes } from '@api/types/translation/TextCodes';
import { Text } from '@components';
import { Box, FormControlLabel, Paper, Radio, Typography } from '@mui/material';
import { t } from '@translations';
import { UseFormRegister, UseFormSetValue, useForm } from 'react-hook-form';

interface DeliveryOptionProps {
  label: string;
  description: string;
  price: string;
  value: string;
}

interface DeliveryOptionForm {
  delivery: 'separated' | 'common';
}

export const DeliveryOptions = () => {
  const { currentData } = useGetShippingMethodsQuery(); //Api not work

  const { register, watch, setValue } = useForm<{ delivery: DeliveryOptionForm['delivery'] }>({
    defaultValues: { delivery: 'common' },
  });
  const selectedValue = watch('delivery');
  const dataFromApi = [
    {
      label: 'Separated deliveries',
      description:
        'All products will be delivered separately as soon as possible. There are several deliveries in different dates.',
      price: 'KR 599',
      value: 'separated',
    },
    {
      label: 'Common delivery',
      description: 'All products will be delivered at the same time.',
      price: 'KR 599',
      value: 'common',
    },
  ];

  return (
    <div>
      <Text variant='h2'>{t(TextCodes.Product.Checkout.DeliveryOption).toLocaleUpperCase()}</Text>

      {dataFromApi.map((data, index) => (
        <DeliveryOption
          key={index}
          {...data}
          register={register}
          name='delivery'
          selectedValue={selectedValue}
          setValue={setValue}
        />
      ))}
    </div>
  );
};

const DeliveryOption: React.FC<
  DeliveryOptionProps & {
    register: UseFormRegister<DeliveryOptionForm>;
    name: keyof DeliveryOptionForm;
    selectedValue: DeliveryOptionForm['delivery'];
    setValue: UseFormSetValue<DeliveryOptionForm>;
  }
> = ({ label, description, price, value, register, name, selectedValue, setValue }) => {
  const isSelected = selectedValue === value;

  return (
    <Paper style={{ padding: '10px', margin: '10px' }}>
      <Box
        display='flex'
        flexDirection='column'
        alignItems='flex-start'
        justifyContent='space-between'
      >
        <Box display='flex' alignItems='center' justifyContent='space-between' width='100%'>
          <Box display='flex' alignItems='center'>
            <FormControlLabel
              control={
                <Radio
                  color='primary'
                  {...register(name)}
                  value={value}
                  checked={isSelected}
                  onClick={() => setValue(name, value as DeliveryOptionForm['delivery'])}
                />
              }
              label={
                <Box marginLeft={2}>
                  <Typography variant='h6'>{label}</Typography>
                  <Typography variant='body2'>{description}</Typography>
                </Box>
              }
            />
          </Box>
          <Typography variant='h6'>{price}</Typography>
        </Box>
      </Box>
    </Paper>
  );
};
